import { CircleMarker, MapContainer, TileLayer, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const TIER_COLORS = {
  priority: "#b91c1c",
  opportunity: "#b45309",
  watch: "#475569",
  none: "#94a3b8",
};

export const MandateMap = ({ communes, selectedCode, onSelect }) => (
  <div className="mandate-map-wrapper" data-testid="mandate-map">
    <MapContainer
      center={[43.92, 5.05]}
      zoom={10}
      scrollWheelZoom={false}
      className="mandate-map"
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {communes.map((commune) => (
        <CircleMarker
          key={commune.commune_code}
          center={[commune.lat, commune.lon]}
          radius={Math.max(6, 5 + commune.opportunity_score / 10)}
          pathOptions={{
            color: selectedCode === commune.commune_code ? "#211038" : TIER_COLORS[commune.tier],
            fillColor: TIER_COLORS[commune.tier],
            fillOpacity: selectedCode === commune.commune_code ? 0.95 : 0.55,
            weight: selectedCode === commune.commune_code ? 3 : 1.5,
          }}
          eventHandlers={{ click: () => onSelect(commune.commune_code) }}
        >
          <Tooltip direction="top" offset={[0, -4]}>
            <strong>{commune.commune}</strong> — {commune.opportunity_score}/100
            <br />
            DVF {commune.signal_counts.dvf} · DPE {commune.signal_counts.dpe} · BODACC {commune.signal_counts.bodacc}
          </Tooltip>
        </CircleMarker>
      ))}
    </MapContainer>
    <div className="mandate-map-legend" data-testid="mandate-map-legend">
      <span><i style={{ background: TIER_COLORS.priority }} /> Priorité ≥ 80</span>
      <span><i style={{ background: TIER_COLORS.opportunity }} /> Opportunité 60-79</span>
      <span><i style={{ background: TIER_COLORS.watch }} /> Veille &lt; 60</span>
      <span><i style={{ background: TIER_COLORS.none }} /> Aucun hotspot</span>
    </div>
  </div>
);
